import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import { PersistGate } from "redux-persist/integration/react";

import "./index.css";
import "react-alice-carousel/lib/alice-carousel.css";

import App from "@/App";

import reportWebVitals from "@/reportWebVitals";

const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

import { register } from "swiper/element/bundle";
import { FirebaseMessagingProvider } from "@/context/Chat";

import { persistor, store } from "./store/slices";

// Register Swiper web component
register();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate
      loading={<div>Loading persisted state...</div>}
      persistor={persistor}
    >
      <AgoraRTCProvider client={client}>
        <FirebaseMessagingProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </FirebaseMessagingProvider>
      </AgoraRTCProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
